/* ============================================================
   Collection Header — INSAURA  |  Sprint 4
   Filter button → custom drawer. Sort button → AJAX via Dawn.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initFilterBtn();
    initSortBtn();
  });

  /* ── Filter button — opens custom filter drawer ─────────────── */
  function initFilterBtn() {
    var btn = document.querySelector('.coll-header__btn--filter');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (window.collFilterDrawer) window.collFilterDrawer.open();
    });
  }

  /* ── Sort options (Shopify sort keys) ────────────────────────── */
  var SORT_OPTIONS = [
    { label: 'Featured',           value: 'manual'       },
    { label: 'Best Selling',       value: 'best-selling'  },
    { label: 'Newest Arrivals',    value: 'created-desc'  },
    { label: 'Top Rated',          value: 'best-selling'  },
    { label: 'Price: Low to High', value: 'price-asc'    },
    { label: 'Price: High to Low', value: 'price-desc'   }
  ];

  /* ── Sort button — custom overlay, dispatches to Dawn's #SortBy ─ */
  function initSortBtn() {
    var btn     = document.querySelector('.coll-header__btn--sort');
    var overlay = document.getElementById('CollHeaderSortOverlay');
    if (!btn || !overlay) return;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (overlay.hidden) {
        buildOverlay(overlay);
        overlay.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      } else {
        closeOverlay(overlay, btn);
      }
    });

    document.addEventListener('click', function (e) {
      if (!overlay.hidden && !overlay.contains(e.target) && e.target !== btn) {
        closeOverlay(overlay, btn);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) {
        closeOverlay(overlay, btn);
        btn.focus();
      }
    });
  }

  function getCurrentSortValue() {
    var select = document.getElementById('SortBy');
    return select ? select.value : 'manual';
  }

  function buildOverlay(overlay) {
    var currentValue = getCurrentSortValue();
    overlay.innerHTML = '';

    SORT_OPTIONS.forEach(function (opt) {
      var item       = document.createElement('button');
      item.type      = 'button';
      item.className = 'coll-header__sort-item';
      if (opt.value === currentValue && opt.label !== 'Top Rated') {
        item.classList.add('is-active');
      }
      item.textContent    = opt.label;
      item.dataset.value  = opt.value;

      item.addEventListener('click', function () {
        var select = document.getElementById('SortBy');
        if (select) {
          /* If the sort value doesn't exist as an option, add it temporarily */
          var exists = Array.from(select.options).some(function (o) {
            return o.value === opt.value;
          });
          if (!exists) {
            var newOpt   = document.createElement('option');
            newOpt.value = opt.value;
            select.appendChild(newOpt);
          }
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          select.dispatchEvent(new Event('input',  { bubbles: true }));
        }
        var sortBtn = document.querySelector('.coll-header__btn--sort');
        closeOverlay(overlay, sortBtn);
      });

      overlay.appendChild(item);
    });
  }

  function closeOverlay(overlay, btn) {
    overlay.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

})();
